import { TableCell, TableRow } from '@mui/material';
import React from 'react';
import TableRowSkeleton from './TableRowSkeleton';

const TableBody = ({
  rows = [],
  columns = [],
  noDataMessage = 'No Data Found',
  loadingRows = [] // Array of row IDs that are currently loading
}) => {
  // return empty state if no data found
  if (!rows || rows.length === 0) {
    return (
      <tbody>
        <TableRow>
          <TableCell style={{ textAlign: 'center' }} colSpan={columns.length}>
            {noDataMessage}
          </TableCell>
        </TableRow>
      </tbody>
    );
  }

  return (
    <tbody>
      {rows.map((row, rowIndex) => {
        const isRowLoading = loadingRows.includes(row.id);
        // Show skeleton for loading rows
        if (isRowLoading) {
          return <TableRowSkeleton key={`skeleton-${row.id || rowIndex}`} columns={columns} />;
        }

        return (
          <TableRow key={row.id || rowIndex}>
            {columns.map((column, columnIndex) => {
              const cellValue = column.field ? row[column.field] : null;

              // Props for custom styling and content alignment
              const tableCellProps = {
                style: { ...(column.cellStyle || {}) },
                align: column.align || 'left'
              };

              // If renderCell is not provided then use default cell value but check for event handlers
              if (!column.renderCell) {
                // handle on click event
                if (column.onClick && typeof column.onClick === 'function') {
                  tableCellProps.onClick = (e) =>
                    column.onClick({
                      row,
                      cellValue,
                      event: e,
                      rowIndex,
                      columnIndex
                    });

                  tableCellProps.style.cursor = 'pointer';
                }

                // handle on change event
                if (column.onChange && typeof column.onChange === 'function') {
                  tableCellProps.onChange = (e) =>
                    column.onChange({
                      row,
                      cellValue,
                      event: e,
                      rowIndex,
                      columnIndex
                    });
                }

                // add other event handles below....
              }

              return (
                <TableCell
                  // Generate a more robust key for each cell using row ID/index and column field/header/index
                  key={`${row.id || rowIndex}-${
                    column.field || column.headerName || columnIndex
                  }`}
                  {...tableCellProps}
                >
                  {
                    column.renderCell
                      ? column.renderCell({
                        value: cellValue,
                        row,
                        rowIndex,
                        columnIndex
                      }) // Pass value, row, and indices to renderCell
                      : cellValue // If no renderCell, display the cellValue. React handles null/undefined by rendering nothing.
                  }
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </tbody>
  );
};

export default TableBody;
